export default "__VITE_ASSET__Bv5bBlv8__"